import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function Popup(props) {
  var trigger = props.trigger,
    className = props.className,
    content = props.content,
    verticalPosition = props.verticalPosition,
    horizontalPosition = props.horizontalPosition;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-popup-wrapper ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-popup-trigger"
  }, trigger), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-popup-content vertical-position-".concat(verticalPosition, " horizontal-position-").concat(horizontalPosition)
  }, content));
}
Popup.defaultProps = {
  className: '',
  verticalPosition: 'top',
  horizontalPosition: 'center'
};
Popup.propTypes = {
  /**
  Popup trigger
   */
  trigger: nodeOrStringProp.isRequired,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Popup content
   */
  content: nodeOrStringProp.isRequired,
  /**
  Vertical position of popup related to its trigger
   */
  verticalPosition: PropTypes.oneOf(['top', 'bottom', 'center']),
  /**
  Horizontal position of popup related to its trigger
   */
  horizontalPosition: PropTypes.oneOf(['left', 'right', 'center'])
};

export default Popup;
